import { get } from 'lodash-es';
import { useEffect, useState } from 'react';

import { LogsFilterInterface } from '@component/tables/log-filter/logs-filter.interface';
import { usePrevious } from '@hook/common/use-previous.hook';
import { useLazyLoadRequestsQuery } from '@hook/requests/consumer-request.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { LogFilterInterface } from '@interface/logs/logs.interface';
import { PaginationCursorResponseInterface } from '@interface/logs/response-data.interface';
import { isExist, isString } from '@util/data/is-exist';

const PAGINATION_PER_PAGE = 10;

export const useRequestLogs = () => {
  const [filter, setFilter] = useState<LogFilterInterface['filter']>(null!);
  const accessToken = useStoreSelector((state) => state.consumers.meta.accessToken);
  const prevAccessToken = usePrevious(accessToken);

  const [action, { isLoading, data }] = useLazyLoadRequestsQuery();

  useEffect(
    () =>
      void (
        isString(accessToken) &&
        prevAccessToken !== accessToken &&
        action({ pagination: { limit: PAGINATION_PER_PAGE }, filter })
      ),
    [accessToken, prevAccessToken],
  );

  const onNext = () =>
    void action({ pagination: { limit: PAGINATION_PER_PAGE, cursor: get(data, 'meta.next') }, filter });

  const onPrevious = () =>
    void action({ pagination: { limit: PAGINATION_PER_PAGE, cursor: get(data, 'meta.previous') }, filter });

  const onChangeFilter = (data: LogsFilterInterface) =>
    setFilter({
      serviceId: data.serviceId,
      dateFrom: data.dateFrom?.toISOString(),
      dateTo: data.dateTo?.toISOString(),
    });

  useEffect(
    () =>
      void (isString(accessToken) && isExist(filter) && action({ pagination: { limit: PAGINATION_PER_PAGE }, filter })),
    [filter, accessToken],
  );

  return {
    data: get(data, 'data', []),
    isLoading,
    pagination: get(data, 'meta') as unknown as PaginationCursorResponseInterface,
    onNext,
    onPrevious,
    onChangeFilter,
  };
};
